
import { useAuthenticationContext } from "../contexts/AuthenticationContext";
import { useOAuth2Context } from "../contexts/OAuth2Context";

export default function LogoutButton() {
  const { userManager } = useOAuth2Context();

  return <button onClick={() =>userManager.signoutRedirect()}>Logout</button>;
}